import { render, staticRenderFns } from "./contentCourseLectureYoutube.vue?vue&type=template&id=50a23323&"
import script from "./contentCourseLectureYoutube.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports